import { useEffect, useState } from "react";

export const useScrollTop: () => number = () => {
  const [scrollTop, setScrollTop] = useState(0);

  useEffect(() => {
    const saveScroll = () => {
      // to work together with useLockBodyScroll for iosDevices
      if (document.documentElement.style.height === "100%") return;
      setScrollTop(window.scrollY);
    };

    saveScroll();

    window.addEventListener("scroll", saveScroll, { passive: true });

    return () => window.removeEventListener("scroll", saveScroll);
  }, []);

  return scrollTop;
};
